<!-- Estonia Licence Modal -->
<modal id="estoniaLicenceModal" class="modal_smooth_open estonian_modal">
  <div class="fixed-scroll">
    <div class="site_modal middleAlignBlock">
      <div class="middleAlign">
        <div class="site_modal--body site_modal--body-small">
          <!-- <div class="mobile_modal_closeicon" (click)="closeModal('finlandModal')">
            ✕
          </div> -->
          <div class="modal__container">
            <div class="modal__heading">
              <h3 class="headingtitle titlepadding">{{'estoniaLicenceModal.estoniaLicence1' | translate}}</h3>
            </div>
            <div class="modal__body">
              <p>{{'estoniaLicenceModal.estoniaLicence2' | translate}}</p>
              <p>{{'estoniaLicenceModal.estoniaLicence3' | translate}}</p>
              <div class="modal__body--btn">
                <button class="startply-btn site-btn site-btn__primary site-btn--lg w-100 mb20"
                  (click)="updateEstoniaPolocyVersion()">{{'estoniaLicenceModal.estoniaLicence4' | translate}}</button>
                  
              </div>
              <p class="estonia_p">{{'estoniaLicenceModal.estoniaLicence5' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>